import { space } from '../../../api/apiPaths';
import { post,get, put, deleteSpace } from '../../../api/commonAPI';
import * as Actions from './AddSuperDealActionTypes';
import toastr from 'toastr';

export const createSuperDeal = (superDealData, onSuccess, onError) => {
  return dispatch => {
    dispatch({ type: Actions.CREATE_SUPER_DEAL });

    post(`${space}/super-deals`, superDealData) 
      .then(res => {
        dispatch({
          type: Actions.CREATE_SUPER_DEAL_SUCCESS,
          payload: res.data
        });
        toastr.success('Super Deal created successfully!');
        if (onSuccess) onSuccess(res.data);
      })
      .catch(error => {
        dispatch({
          type: Actions.CREATE_SUPER_DEAL_FAILS,
          payload: error
        });
        const errorMessage = error.response?.data?.errors?.[0] || 'Failed to create super deal';
        toastr.error(errorMessage);
        if (onError) onError(error);
      });
  };
};

export const fetchSuperDeals = () => {
  return dispatch => {
    dispatch({ type: Actions.FETCH_SUPER_DEALS });
    get(`${space}/super-deals`)
      .then(res => {
        dispatch({
          type: Actions.FETCH_SUPER_DEALS_SUCCESS,
          payload: res.data
        });
      })
      .catch(error => {
        dispatch({
          type: Actions.FETCH_SUPER_DEALS_FAILS,
          payload: error
        });
        toastr.error('Failed to fetch super deals');
      });
  };
};

export const deleteSuperDeal = (id, onSuccess, onError) => {
  return dispatch => {
    dispatch({ type: Actions.DELETE_SUPER_DEAL });
    deleteSpace(`${space}/super-deals/${id}`)
      .then(() => {
        dispatch({
          type: Actions.DELETE_SUPER_DEAL_SUCCESS,
          payload: id
        });
        toastr.success('Super deal deleted successfully!');
        if (onSuccess) onSuccess();
      })
      .catch(error => {
        dispatch({
          type: Actions.DELETE_SUPER_DEAL_FAILS,
          payload: error
        });
        toastr.error('Failed to delete super deal');
        if (onError) onError(error);
      });
  };
};